/*
 * Copyright 2019-2020 Soul Machines Ltd. All Rights Reserved.
 */

export enum SpeechState {
  Idle = 'idle',
  Animating = 'animating',
  Speaking = 'speaking',
}
